'use client'
// Components
import { Box, Icon, Typography, Skeleton } from '@/CommonComponents'
import { Collapse as MUICollapse } from '@mui/material'
import ClicableItem from '../hoc/ClickableItem'
// Hooks
import { useState } from 'react'
interface IDetailSectionProps {
  title: string
  children: React.ReactNode
  defaultExpanded?: boolean
  loading?: boolean
}

export default function DetailSection({ title, children, defaultExpanded, loading }: IDetailSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  return loading ? (
    <Skeleton variant="rectangular" height={200} />
  ) : (
    <>
      <ClicableItem
        onClick={() => {
          setIsExpanded((expanded) => !expanded)
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2" bold>
            {title}
          </Typography>
          <Icon icon={isExpanded ? 'expandLess' : 'expandMore'} sx={{ mr: 5 }} />
        </Box>
      </ClicableItem>
      <MUICollapse in={isExpanded}>{children}</MUICollapse>
    </>
  )
}
